/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_Done_LoadingInputs */



/**
* | output |
* | --- |
* | "One moment…" |
*
* @param {Meeting_Prep_Actions_Done_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_loading = /** @type {((inputs?: Meeting_Prep_Actions_Done_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Even geduld…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un instant…")
	return /** @type {LocalizedString} */ ("One moment…")
});